import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import useOnClickOutside from "../Popover/useOnClickOutside.js";
import { onMessageListener } from "../../firebase.js";
import {
	PopoverWrapper,
	NotificationContainer,
	NotificationBadgeContainer,
	PopOver,
	PopOverHeader,
	PopOverContent,
	PopOverFooter,
	NotificationItem,
	NotificationItemIcon,
	NotificationItemContent,
	NotificationItemMark,
	LoaderWrapper,
} from "./NotificationPopUp.style";
import Loader from "../Loader/Loader";
import { Notification } from "../../assets/icons/Notification.js";
import BuyNormal from "../../assets/icons/buy.jpg";
import BuyExpress from "../../assets/icons/buy_express.jpg";
import ExpressImg from "../../assets/icons/delixpress_logo2.svg";
import NormalImg from "../../assets/icons/delishop_logo2.svg";
import Wallet from "../../assets/icons/wallet.svg";
import BackInStock from "../../assets/images/back-in-stock.jpg";
import AbandonedBasketIcon from "../../assets/images/abandoned-basket.jpg";
import API from "../../network/redAPI.js";
import t from "../../i18n/translate";
import { debounce } from "lodash";
import { initBasket } from "../../store/actions/cartAction.js";

const lang = localStorage.getItem("lang");

const getSentPeriod = (sent_time) => {
	let now = new Date();
	let sent_date = new Date(sent_time);
	let time = now - sent_date;
	let period = 0;
	let typeOfTime = "";
	let result = "";

	if (time / (1000 * 60 * 60 * 24 * 7 * 30 * 12) >= 1) {
		period = Math.floor(time / (1000 * 60 * 60 * 24 * 7 * 30 * 12));
		typeOfTime = "year";
	} else if (time / (1000 * 60 * 60 * 24 * 7 * 30) >= 1) {
		period = Math.floor(time / (1000 * 60 * 60 * 24 * 7 * 30));
		typeOfTime = "month";
	} else if (time / (1000 * 60 * 60 * 24 * 7) >= 1) {
		period = Math.floor(time / (1000 * 60 * 60 * 24 * 7));
		typeOfTime = "week";
	} else if (time / (1000 * 60 * 60 * 24) >= 1) {
		period = Math.floor(time / (1000 * 60 * 60 * 24));
		typeOfTime = "day";
	} else if (time / (1000 * 60 * 60) >= 1) {
		period = Math.floor(time / (1000 * 60 * 60));
		typeOfTime = "hour";
	} else if (time / (1000 * 60) >= 1) {
		period = Math.floor(time / (1000 * 60));
		typeOfTime = "minute";
	}

	if (period > 1) result = period + " " + typeOfTime + "s ago";
	else if (period === 1) result = period + " " + typeOfTime + " ago";
	else result = "just now";

	return result;
};

const NotificationPopUpItem = ({ props, notification, setOpenState }) => {
	const dispatch = useDispatch();

	const handleClickNotification = (e, notification) => {
		e.preventDefault();
		API.MarkNotification({ notification_id: notification.notificationId })
			.then((response) => response.json())
			.then((data) => {
				if (data.success) {
					if (notification.type.includes("order")) {
						if (notification.data.express) {
							initBasket("express", dispatch);
							localStorage.setItem("expressMode", true);
						}
						window.location.href = `/all-orders`;
						localStorage.setItem("notificationID", notification.data.order.number);
					} else {
						if (notification.type === "favorite") {
							initBasket("normal", dispatch);
							localStorage.removeItem("expressMode");
							window.location.href = `/favorites?notificationId=${notification.notificationId}`;
						}else{
							if (
								notification?.data?.generalData?.type === 8 ||
								notification.type === "expressBasket"
							) {
								initBasket("express", dispatch);
								localStorage.setItem("expressMode", true);
							} else if (notification.type === "normalBasket") {
								initBasket("normal", dispatch);
								localStorage.removeItem("expressMode");
							} 
							setOpenState(true);
							window.location.href = `/notification/${notification.notificationId}`;
						}
					}
				}
			});
	};

	return (
		notification !== null && (
			<NotificationItem
				className={`notification-item ${!notification.new ? "unread" : ""}`}
				onClick={(e) => {
					handleClickNotification(e, notification);
				}}
			>
				<NotificationItemIcon>
					<div>
						<img
							src={
								["campaign", "general","landingPage","partnerPage"].includes(notification.type)
									? notification.data.icon
										? notification.data.icon
										: notification?.data?.generalData?.type === 8
										? ExpressImg
										: props.cartType === "express"
										? ExpressImg
										: NormalImg
									: notification.type === "favorite"
									? BackInStock
									: notification.type === "abandonedBasket"
									? AbandonedBasketIcon
									: notification.type === "walletUpdate"
									? Wallet
									: notification.type.includes("order")
									? notification.data.express
										? BuyExpress
										: BuyNormal
									: notification.type === "expressBasket"
									? BuyExpress
									: notification.type === "normalBasket"
									? BuyNormal
									: props.cartType === "express"
									? ExpressImg
									: NormalImg
							}
							alt={notification?.type}
						/>
					</div>
				</NotificationItemIcon>
				<NotificationItemContent>
					<div className="title">
						{["campaign", "general", "normalBasket", "expressBasket", "favorite", 'abandonedBasket',"landingPage","partnerPage"].includes(
							notification.type
						) ? (
							<div dangerouslySetInnerHTML={{ __html: notification.data.title }} />
						) : notification.type === "walletUpdate" ? (
							notification.data.content.title
						) : (
							<p>Order No: #{notification.data.order.number}</p>
						)}
					</div>
					<div>
						{["campaign", "general", "normalBasket", "expressBasket", "favorite", 'abandonedBasket',"landingPage","partnerPage"].includes(
							notification.type
						) ? (
							<div dangerouslySetInnerHTML={{ __html: notification.data.body }} />
						) : notification.type === "walletUpdate" ? (
							lang === "km" ? (
								notification.data.content.description.km
							) : (
								notification.data.content.description.en
							)
						) : (
							<span className="text-muted">{notification.data.order.description}</span>
						)}
					</div>
					<p className="time">{getSentPeriod(notification.date)}</p>
				</NotificationItemContent>
				<NotificationItemMark>
					<div className={!notification.new ? "unmark" : "mark"}></div>
				</NotificationItemMark>
			</NotificationItem>
		)
	);
};

const NotificationPopUp = ({
	props,
	className,
	handler,
	direction,
	isHomePage,
}) => {
	// Popover State
	const [openstate, setOpenState] = useState(false);
	const [reloadData, setReloadData] = useState(false);
	const cartType = useSelector((state) => state.cartReducer.cartType);

	const [markAsRead, setMarkAsRead] = useState(false);
	const [markAsReadClicked, setMarkAsReadClicked] = useState(false);

	// Ref
	const ref = useRef();
	const scrollRef = useRef(null);

	// Add all classs to an array
	const addAllClasses = ["popover-wrapper"];

	// className prop checking
	if (className) {
		addAllClasses.push(className);
	}

	isHomePage =
		isHomePage && !(window.location.pathname.indexOf("notification") === 1);

	const handleNotificationScroll = useCallback(
		debounce((e) => {
			e.stopPropagation();
			if (!props.has_more) return;
			if (
				scrollRef.current?.clientHeight + scrollRef.current?.scrollTop >=
				scrollRef.current?.scrollHeight - 1
			) {
				if (props.notifications.length % 10 === 0 && props.page >= 1) {
					props.getAllNotifications({
						page: props.notification_page + 1,
						limit: 10,
					});
					props.changeNotificationPage({ page: props.notification_page + 1 });
				}
			}
		}, 250),
		[props.notifications, props.notification_page]
	);

	const handleMarkAllAsRead = async (e) => {
		e.preventDefault();
		setMarkAsReadClicked(true);
		if (props && props.unread_notification >= 1) {
			props.markAllAsRead();
			setMarkAsRead(true);
		}
	};

	// Toggle Popover content
	const handleToggle = (e) => {
		e.stopPropagation();
		if (markAsReadClicked) {
			setMarkAsReadClicked(false);
			return;
		}

		if (window.innerWidth < 420) {
			setOpenState((openstate) => true);
		} else {
			setOpenState((openstate) => !openstate);
		}
	};

	// Handle document click
	const handleDocumentClick = (e) => {
		e.stopPropagation();
		if (openstate) {
			handleToggle(e);
		}
	};

	useEffect(async () => {
		if (localStorage.getItem("admin")) return;
		if (props) {
			props.getAllNotifications({
				page: props.page,
				limit: 10,
			});
			props.getCountUnreadNotifications();
		}
	}, []);

	useEffect(async () => {
		if (localStorage.getItem("admin")) return;
		if (props && props.showNotification && !reloadData) {
			setReloadData(true);
			props.resetNotificationPage();
			props.getAllNotifications({
				page: 1,
				limit: 10,
			});
			props.getCountUnreadNotifications();
		} else if (props && !props.showNotification && reloadData) {
			setReloadData(false);
		}
	}, [props]);

	useEffect(() => {
		if (localStorage.getItem("admin")) return;
		if (
			props &&
			(props.unread_notification !== 0 || props.notifications.length >= 1)
		)
			return;

		if (markAsRead) {
			props.getAllNotifications({
				page: 1,
				limit: 10,
			});
			setMarkAsRead(false);
		}
	}, [props]);

	// Handle window event listener
	useEffect(() => {
		window.addEventListener("click", handleDocumentClick);
		return () => {
			window.removeEventListener("click", handleDocumentClick);
		};
	});

	// Close popover on click outside
	useOnClickOutside(ref, () => setOpenState((popstate) => false));

	return (
		<PopoverWrapper className={addAllClasses.join(" ")} ref={ref}>
			<NotificationContainer
				className={!isHomePage ? "right-0" : ""}
				onClick={handleToggle}
			>
				<Notification />
				{typeof props !== "undefined" && props.unread_notification >= 1 && (
					<NotificationBadgeContainer className={cartType}>
						{props.unread_notification}
					</NotificationBadgeContainer>
				)}
			</NotificationContainer>
			{/* <div className="popover-handler">
          {handler}
          </div> */}

			{openstate && (
				<PopOver
					className={
						!isHomePage && !window.location.pathname.includes("all-orders")
							? "right-n"
							: ""
					}
				>
					<PopOverHeader>
						<span className="title">{t("notification_title")}</span>
						<div
							className={`markAsRead ${
								!props.notifications.some((n) => n.new === true) ? "disabled" : ""
							}`}
							onClick={(e) => handleMarkAllAsRead(e)}
						>
							{t("notification_mark_all_as_read")}
						</div>
					</PopOverHeader>
					<PopOverContent
						id="NotificationList"
						className={`notification-list ${cartType}`}
						ref={scrollRef}
						onScroll={(e) => handleNotificationScroll(e)}
					>
						{typeof props !== "undefined" &&
							typeof props.notifications !== "undefined" &&
							props.notifications.map((notification) => {
								return (
									<NotificationPopUpItem
										key={notification.notificationId}
										props={props}
										notification={notification}
										setOpenState={setOpenState}
									/>
								);
							})}
						{props !== "undefined" && props.notifcation_loading ? (
							<LoaderWrapper>
								<Loader
									color={localStorage.getItem("expressMode") ? "#f01266" : "#9cc54b"}
									h="40"
									style={{
										borderBottom: `3px solid ${
											localStorage.getItem("expressMode") ? "#f01266" : "#9cc54b"
										}`,
									}}
								/>
							</LoaderWrapper>
						) : null}
					</PopOverContent>
					<PopOverFooter></PopOverFooter>
				</PopOver>
			)}
		</PopoverWrapper>
	);
};

export default NotificationPopUp;
